import axios from '@/core/axios';
import { CollectionList } from '../collections/collections.types';
import { RunnersQuest, RunnersQuestsListOptions } from './runners-quests.types';

export class RunnersQuestsService {
  list(opts: RunnersQuestsListOptions = {}): Promise<CollectionList<'runners-quests'>> {
    const { filters, pagination } = opts;
    const { fulltext, ...restFilters } = filters || {};
    return axios
      .get<CollectionList<'runners-quests'>>('/runners-quests', {
        params: { ...restFilters, ...pagination, ...(fulltext ? { text: fulltext } : {}) }
      })
      .then(resp => resp?.data);
  }

  create(serialNo: string): Promise<RunnersQuest> {
    return axios.post<RunnersQuest>('/runners-quests', { serial_no: serialNo }).then(resp => resp?.data);
  }

  update(id: number, data: Partial<RunnersQuest>): Promise<RunnersQuest> {
    return axios.put<RunnersQuest>(`/runners-quests/${id}`, data).then(resp => resp?.data);
  }

  delete(id: number): Promise<void> {
    return axios.delete(`/runners-quests/${id}`).then(() => undefined);
  }

  deleteByBac(bac: string): Promise<void> {
    return axios.delete(`/runners-quests/by-bac/${bac}`).then(() => undefined);
  }
}

export const runnersQuestsService = new RunnersQuestsService();
